module.exports = "/assets/data/3666489dad501c385671b414f21b8187-DE22.data.json";